"use client";

import LandingPage from "@/components/home/LandingPage";

export default function Home() {
  return <LandingPage />;
}
